import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { INotification } from '../../api';

interface ToastItem {
  id: string;
  notification: INotification;
}

export function NotificationToastContainer() {
  const [toasts, setToasts] = useState<ToastItem[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    function onNew(e: Event) {
      const notification = (e as CustomEvent<INotification>).detail;
      const item: ToastItem = { id: crypto.randomUUID(), notification };
      setToasts((prev) => [...prev, item]);
      setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== item.id));
      }, 4_000);
    }
    window.addEventListener('notification:new', onNew);
    return () => window.removeEventListener('notification:new', onNew);
  }, []);

  if (toasts.length === 0) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 16,
      right: 16,
      zIndex: 9999,
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
    }}>
      {toasts.map(({ id, notification }) => (
        <div
          key={id}
          style={{
            background: 'var(--color-toast-bg)',
            color: 'var(--color-toast-text)',
            borderRadius: 10,
            padding: '12px 16px',
            boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
            minWidth: 280,
            maxWidth: 360,
            display: 'flex',
            alignItems: 'flex-start',
            gap: 12,
          }}
        >
          <div style={{ flex: 1, minWidth: 0 }}>
            <p style={{ margin: 0, fontSize: 13, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {notification.title}
            </p>
            <p style={{ margin: '2px 0 0', fontSize: 12, color: 'var(--color-neutral-icon)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {notification.message}
            </p>
          </div>
          {notification.url && (
            <button
              onClick={() => navigate(notification.url!)}
              style={{
                background: 'var(--color-toast-action-bg)',
                color: 'var(--color-surface)',
                border: 'none',
                borderRadius: 6,
                padding: '4px 10px',
                fontSize: 12,
                cursor: 'pointer',
                flexShrink: 0,
                fontWeight: 500,
              }}
            >
              Ver
            </button>
          )}
          <button
            onClick={() => setToasts((prev) => prev.filter((t) => t.id !== id))}
            style={{
              background: 'none',
              border: 'none',
              color: 'var(--color-toast-close)',
              cursor: 'pointer',
              padding: 2,
              fontSize: 16,
              lineHeight: 1,
              flexShrink: 0,
            }}
            aria-label="Cerrar"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
